import './job.css';
import { useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import Mail from '../../img/mail.png';
import Cloud from '../../img/cloud.png';
import cb from '../../img/corporate_benefit.png';
import benefitsme from '../../img/benfitsme_neu.png';
import online_lernen from '../../img/online-lernen.png';
import rdp from '../../img/rdp.png';
import check from '../../img/check.png';
import cateringpng from '../../img/cateringpng.png';
import cleaningpng from '../../img/cleaningpng.png';
import infopng from '../../img/info.png';

import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { DataContext } from '../../context/DataContext';
import { doRegister_PNs } from '../PushNotificationFCM';
import { Capacitor } from '@capacitor/core';

const useStyles_2 = makeStyles( ( theme ) => ( {
  root: {
    width: '100%',
  },
  heading: {
    fontSize: 'large',
    fontWeight: 'bold',
    backgroundColor: '#55ba5e',
    color: '#fff',
  },
} ) );

export default function Job()
{
  const { appLdapUsername, appToken } = useContext( DataContext );

  const [ docs, setDocs ] = useState( null );
  const [ cleaning, setCleaning ] = useState( null );
  const [ catering, setCatering ] = useState( null );

  const classes = useStyles_2();

  useEffect( () =>
  {
    var requestOptions = {
      method: 'GET',
      redirect: 'manual',
      credentials: 'same-origin',
    };

    fetch( 'https://intranet-backend.procuratio.com/g_qm_doc.php', requestOptions )
      .then( ( response ) => response.json() )
      .then( ( result ) =>
      {
        setDocs( [ result.data ] );
      } )
      .catch( ( error ) => console.log( 'error', error ) );

    // setUser(localStorage.getItem("ldap_username"));

    let token = localStorage.getItem( 'token' );
    var requestOptions = {
      method: 'GET',
      redirect: 'follow',
      credentials: 'same-origin',
      headers: {
        Authorization: 'Bearer ' + token,
      },
    };
  }, [] );

  function shortenItem( item )
  {
    let short = item.split( '/' );
    let letztesItem = short.length - 1;
    return short[ letztesItem ];
  }

  function browseDir( item )
  {
    return item.dirName && item.dirName !== null ? (
      <>
        <Accordion style={{ marginLeft: '40px', border: '4px solid white' }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={item.dirName}
            id={item.dirName}
            className={classes.heading}
          >
            <Typography className={classes.heading}>{shortenItem( item.dirName )}</Typography>
          </AccordionSummary>
          {item.files.length > 0 ? (
            <AccordionDetails>
              <ol>
                {item.files.length > 0
                  ? item.files.map( ( x ) =>
                  {
                    return (
                      <li className="box_highlight" id="catering">
                        <a href={x.fileName} target="_blank">
                          {shortenItem( x.fileName )}
                        </a>
                      </li>
                    );
                  } )
                  : ''}
              </ol>
            </AccordionDetails>
          ) : (
            ''
          )}

          {item.children.length > 0 ? item.children.map( ( it ) => browseDir( it ) ) : ''}
        </Accordion>
      </>
    ) : (
      ''
    );
  }

  return (
    <div id="wrapper" style={{ padding: '50px' }}>
      <div className="section_title">Arbeitsplatz</div>
      <div className="jobbox">
        <div className="job_button">
          <div className="job_button_header">
            Web<br></br>Mailing
          </div>
          <a className="a_box" href="https://mail.procuratio.com" target="_blank">
            <img className="job_button_image" src={Mail}></img>
          </a>
          Meine<br></br>E-Mails
        </div>
        <div className="job_button">
          <div className="job_button_header">
            Cloud<br></br>Speicher
          </div>
          <a className="a_box" href="https://files.procuratio.com:8441" target="_blank">
            <img className="job_button_image" src={Cloud}></img>
          </a>
          Meine<br></br>Dateien
        </div>
        <div className="job_button">
          <div className="job_button_header">
            Benefits.me
            <br />
            &nbsp;
          </div>
          <Link className="a_box" to="/benefits">
            <img className="job_button_image" src={benefitsme}></img>
          </Link>
          Mitarbeiter
          <br />
          Vorteile
        </div>
        <div className="job_button">
          <div className="job_button_header">
            Corporate
            <br />
            Benefits
          </div>
          <Link className="a_box" to="/corporatebenefit">
            <img className="job_button_image" src={cb}></img>
          </Link>
          Mitarbeiter
          <br />
          Vorteile
        </div>
        <div className="job_button">
          <div className="job_button_header">
            Relias
            <br />
            E-Learning
          </div>
          <a className="a_box" href="https://akademie.training.relias.de" target="_blank">
            <img className="job_button_image" src={online_lernen}></img>
          </a>
          Meine
          <br />
          Schulungen
        </div>
        <div className="job_button">
          <div className="job_button_header">
            Remote
            <br />
            Access
          </div>
          <a className="a_box" href="https://desktop.procuratio.com" target="_blank">
            <img className="job_button_image" src={rdp}></img>
          </a>
          Desktop
          <br />
          Zugang
        </div>
        <div className="job_button">
          <div className="job_button_header">
            Eco
            <br />
            Chexx
          </div>
          <a
            className="a_box"
            href="https://ecochexx-net.com/Login_EcoChexx.php?cotry_cISOCode=DE&lange_cCode=DE"
            target="_blank"
          >
            <img className="job_button_image" src={check}></img>
          </a>
          Meine Checklisten
        </div>
        <div className="job_button">
          <div className="job_button_header">
            Meeting-
            <br />
            unterlagen
          </div>
          <Link to={'/cleaning'}>
            <img className="job_button_image" src={cleaningpng}></img>
          </Link>
          <Link to={'/cleaning'}>Cleaning</Link>
        </div>
        <div className="job_button">
          <div className="job_button_header">
            Meeting-
            <br />
            unterlagen
          </div>
          <Link to={'/catering'}>
            <img className="job_button_image" src={cateringpng}></img>
          </Link>
          <Link to={'/catering'}>Catering</Link>
        </div>
        <div className="job_button">
          <div className="job_button_header">
            Hardware<br /><br />
          </div>
          <Link to={'/HardwareBestellung'}>
            <img className="job_button_image" src={infopng}></img>
          </Link>
          <Link to={'/HardwareBestellung'}>Bestellung</Link>
        </div>
        {
          Capacitor.getPlatform() === 'web'
            ?
              null
            :
              <div className="job_button">
                <div className="job_button_header">
                  Push Notifications<br />
                </div>
                <img className="job_button_image" src={infopng}
                  onClick={() => doRegister_PNs( appLdapUsername, appToken )} ></img>
                <span onClick={() => alert( 'last christmas' )} >aktivieren (nur auf Handys)</span>
              </div>
        }

        <p style={{ clear: 'both' }} />
      </div>

      <div className="section_title">Dokumente</div>

      <div className="rounded_corner_right"></div>
      <div className="DA_info_container">
        <div className="box_highlight">{docs !== null && docs.map( ( e ) => browseDir( e ) )}</div>
      </div>
    </div>
  );
}
